import React, { SFC } from 'react';

interface StepperProps {
  value: number;
  plusDisabled?: boolean;
  minusDisabled?: boolean;
  onPlusClick?: () => void;
  onMinusClick?: () => void;
}

export const Stepper: SFC<StepperProps> = ({
  value,
  plusDisabled = false,
  onPlusClick = () => {},
  minusDisabled = false,
  onMinusClick = () => {},
}) => {
  return (
    <div className="mx-stepper">
      <button disabled={minusDisabled} onClick={onMinusClick}>
        <span>−</span>
      </button>
      <input type="text" value={value} readOnly />
      <button disabled={plusDisabled} onClick={onPlusClick}>
        <span>+</span>
      </button>
    </div>
  );
};
